import React, { FC } from 'react'
import imgSrc from '../../assets/errors/no_connection.svg'
import Box from '@mui/material/Box'
import { Text } from './styled'

const ErrorBadConnection: FC = () => {
	return (
		<Box
			display={'flex'}
			flexDirection={'column'}
			alignItems={'center'}
			maxWidth={'22rem'}
			minWidth={'14.5rem'}
		>
			<img src={imgSrc} alt={''} loading={'lazy'} width={232} />
			<Text paragraph mt={9} mb={0} lineHeight={1}>
				Please check your internet connection
			</Text>
		</Box>
	)
}

export default ErrorBadConnection
